export default __webpack_public_path__ + "static/media/device_white_bg.d37ce784.svg";